"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateContract = class CreateContract extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_contract_type = new core_1.ComponentValueCache(this, "contract_type", "CreateContract.contractType");
    }
    mapDefaultContract(...args) {
        const data = args[0];
        return _.extend(data, { counterparty: {}, rental: {} });
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    contract_type;
    contract;
    async $$load_contract() {
        return this.$fn.fetch('read_contract', {
            parameters: {
                id: 'defaults',
                type: this.$data.contract_type,
                rental: this.rentalId
            }
        });
    }
    contractTypes;
    async $$load_contractTypes() {
        return this.$fn.getEnumValuesFromSchema('ContractTypes');
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    currentTab;
    categories;
    async $$load_categories() {
        return this.$fn.fetch('list_contract_category');
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['contract_type', 'contract', 'contractTypes', 'formName', 'formId', 'labelAlign', 'currentTab', 'categories', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                contract_type: "rental",
                contract: null,
                contractTypes: null,
                formName: "contract",
                formId: null,
                labelAlign: "left",
                currentTab: 0,
                categories: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get companyTranslation() {
        if (this.loaded) {
            return ['rental', 'rental_agreement', 'parking'].indexOf(this.contract.contract_type) > -1 ?
                this.$fn.pgettext('Contract', 'Lessor') :
                this.$fn.pgettext('Contract', 'Company');
        }
        return null;
    }
    get counterpartyTranslation() {
        if (this.loaded) {
            return ['rental', 'rental_agreement', 'parking'].indexOf(this.contract.contract_type) > -1 ?
                this.$fn.pgettext('Contract', 'Tenant') :
                this.$fn.pgettext('Contract', 'Counterparty');
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Create Contract"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3092_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_setData_3098_getActionArgs($event) {
        return {
            path: "contract",
            value: this.mapDefaultContract($event.data.response.data),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_7789867021953041_request_3096_getActionArgs($event) {
        return {
            operation: "read_contract",
            parameters: {
                id: "defaults",
                type: $event.data.value,
            },
        };
    }
    async evh_7789867021953041_optionSelected(event, scope) {
        return await this.actions.evh_7789867021953041_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_2140198529698299_setData_3100_getActionArgs($event) {
        return {
            path: "currentTab",
            value: this.currentTab - 1,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2140198529698299_clickPreventStop(event, scope) {
        return await this.actions.evh_2140198529698299_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8790374038998522_setData_3102_getActionArgs($event) {
        return {
            path: "currentTab",
            value: this.currentTab + 1,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_8790374038998522_clickPreventStop(event, scope) {
        return await this.actions.evh_8790374038998522_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_309864017738714_reloadSlickgrid_3106_getActionArgs($event) {
        return {
            grid: "contracts",
        };
    }
    async act_309864017738714_closeComponent_3108_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async act_309864017738714_navigate_3110_getActionArgs($event) {
        return {
            location: {
                name: "app.contract",
                params: {
                    id: $event.data.id,
                },
            },
        };
    }
    async act_309864017738714_crud_3104_getActionArgs($event) {
        return {
            objectType: "contract",
            op: "upsert",
            data: this.contract,
        };
    }
    async evh_309864017738714_clickPreventStop(event, scope) {
        return await this.actions.evh_309864017738714_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1589624209624921_clickPreventStop(event, scope) {
        return await this.actions.evh_1589624209624921_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3092 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3092_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3091 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3092,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3091],
        });
        const act_2248226175642056_closeComponent_3094 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3093 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3094,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3093],
        });
        const act_7789867021953041_setData_3098 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_3098_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_success_3097 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_3098,
            event: "success",
            displayName: "setData",
        });
        const act_7789867021953041_request_3096 = new core_1.actions.RequestAction({
            actionArgs: this.act_7789867021953041_request_3096_getActionArgs,
            events: [evh_7789867021953041_success_3097],
        });
        const evh_7789867021953041_optionSelected_3095 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_request_3096,
            event: "optionSelected",
            displayName: "request",
        });
        const evh_7789867021953041_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_optionSelected_3095],
        });
        const act_2140198529698299_setData_3100 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2140198529698299_setData_3100_getActionArgs,
            events: [],
        });
        const evh_2140198529698299_clickPreventStop_3099 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_setData_3100,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const evh_2140198529698299_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2140198529698299_clickPreventStop_3099],
        });
        const act_8790374038998522_setData_3102 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8790374038998522_setData_3102_getActionArgs,
            events: [],
        });
        const evh_8790374038998522_clickPreventStop_3101 = new core_1.actions.EventHandlerImpl({
            action: act_8790374038998522_setData_3102,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const evh_8790374038998522_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8790374038998522_clickPreventStop_3101],
        });
        const act_309864017738714_reloadSlickgrid_3106 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_309864017738714_reloadSlickgrid_3106_getActionArgs,
            events: [],
        });
        const evh_309864017738714_success_3105 = new core_1.actions.EventHandlerImpl({
            action: act_309864017738714_reloadSlickgrid_3106,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_309864017738714_closeComponent_3108 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_309864017738714_closeComponent_3108_getActionArgs,
            events: [],
        });
        const evh_309864017738714_success_3107 = new core_1.actions.EventHandlerImpl({
            action: act_309864017738714_closeComponent_3108,
            event: "success",
            displayName: "closeComponent",
        });
        const act_309864017738714_navigate_3110 = new core_1.actions.NavigateAction({
            actionArgs: this.act_309864017738714_navigate_3110_getActionArgs,
            events: [],
        });
        const evh_309864017738714_success_3109 = new core_1.actions.EventHandlerImpl({
            action: act_309864017738714_navigate_3110,
            event: "success",
            displayName: "navigate",
        });
        const act_309864017738714_crud_3104 = new core_1.actions.CRUDAction({
            actionArgs: this.act_309864017738714_crud_3104_getActionArgs,
            displayName: "save",
            events: [evh_309864017738714_success_3105, evh_309864017738714_success_3107, evh_309864017738714_success_3109],
        });
        const evh_309864017738714_clickPreventStop_3103 = new core_1.actions.EventHandlerImpl({
            action: act_309864017738714_crud_3104,
            event: "click.prevent.stop",
            displayName: "save",
        });
        const evh_309864017738714_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_309864017738714_clickPreventStop_3103],
        });
        const act_1589624209624921_closeModal_3112 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_1589624209624921_clickPreventStop_3111 = new core_1.actions.EventHandlerImpl({
            action: act_1589624209624921_closeModal_3112,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1589624209624921_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1589624209624921_clickPreventStop_3111],
        });
        return {
            act_7315092382398562_closeModal_3092,
            evh_7315092382398562_close_3091,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3094,
            evh_2248226175642056_close_3093,
            evh_2248226175642056_close,
            act_7789867021953041_setData_3098,
            evh_7789867021953041_success_3097,
            act_7789867021953041_request_3096,
            evh_7789867021953041_optionSelected_3095,
            evh_7789867021953041_optionSelected,
            act_2140198529698299_setData_3100,
            evh_2140198529698299_clickPreventStop_3099,
            evh_2140198529698299_clickPreventStop,
            act_8790374038998522_setData_3102,
            evh_8790374038998522_clickPreventStop_3101,
            evh_8790374038998522_clickPreventStop,
            act_309864017738714_reloadSlickgrid_3106,
            evh_309864017738714_success_3105,
            act_309864017738714_closeComponent_3108,
            evh_309864017738714_success_3107,
            act_309864017738714_navigate_3110,
            evh_309864017738714_success_3109,
            act_309864017738714_crud_3104,
            evh_309864017738714_clickPreventStop_3103,
            evh_309864017738714_clickPreventStop,
            act_1589624209624921_closeModal_3112,
            evh_1589624209624921_clickPreventStop_3111,
            evh_1589624209624921_clickPreventStop,
            save: act_309864017738714_crud_3104,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], CreateContract.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateContract.prototype, "onRental_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], CreateContract.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateContract.prototype, "onSize", null);
CreateContract = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateContract);
exports.default = CreateContract;
vue_property_decorator_1.Vue.component("CreateContract", CreateContract);
